import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "topIconText" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "gameBrandContainer" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = ["innerHTML"]

import { computed } from 'vue';
import { FooterImagesItem } from '@/view/home/supportScript';
import { useGameStore } from '@/stores/games';


export default /*@__PURE__*/_defineComponent({
  __name: 'footerText',
  props: {
    itemData: {}
  },
  emits: ['openContactPopup'],
  setup(__props: any, { emit: __emit }) {

function resolveText(text: string | Record<string, string>): string {
  if (typeof text === 'string') return text
  const lang = localStorage.getItem('lang') || 'en'
  return text[lang] || text['en'] || ''
}

function resolveImage(item: FooterImagesItem | Record<string, FooterImagesItem>): FooterImagesItem {
  if (!item) return { display: false, url: '', redirectUrl: '' }
  if ('url' in item) return item as FooterImagesItem
  const lang = localStorage.getItem('lang') || 'en'
  const localized = item as Record<string, FooterImagesItem>
  return localized[lang] || localized['en'] || { display: false, url: '', redirectUrl: '' }
}

const gameStore = useGameStore()
const groupList = computed(() => gameStore.groupList)
const props = __props
const emits = __emit
const footerImage1 = computed(() => resolveImage(props.itemData.footerImage1))
const footerHtmlText = computed(() => resolveText(props.itemData.htmlText))
const welcomeText = computed(() => resolveText(props.itemData.htmlWelcomeText?.text || ''))
const copywriteText = computed(() => resolveText(props.itemData.htmlCopywriteText?.text || ''))
const openContactPopup = () => {
    emits('openContactPopup')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (footerImage1.value.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: footerImage1.value.url,
            alt: "",
            width: "35%"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.itemData?.htmlWelcomeText?.display)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "welcomeText",
            innerHTML: welcomeText.value
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.itemData?.htmlCopywriteText?.display)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "copywriteText",
            innerHTML: copywriteText.value
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_van_row, { style: {"padding":"15px 0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('home.gameGenre')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "11",
            offset: "1",
            style: {"text-align":"left"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('home.gameGenre')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, { style: {"padding":"15px 0","font-weight":"400"} }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Slot")
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "11",
            offset: "1",
            class: "gameCol",
            style: {"color":"#616d93"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupList.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(item.name), 1))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line" }, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", { innerHTML: footerHtmlText.value }, null, 8, _hoisted_8)
    ])
  ]))
}
}

})